import React, { useState, useEffect } from "react";
import { doc, setDoc, getDoc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import {
  MdAccountCircle,
  MdPhone,
  MdCallReceived,
} from "react-icons/md";
import { Toast } from "../components_root/ToastContext";
import { Randomcode } from "../components_root/rendom_code";

// Generate guestId if not in localStorage
function getGuestId() {
  let guestId = localStorage.getItem("guestId");
  if (!guestId) {
    guestId = "guest_" + Math.random().toString(36).substring(2, 12);
    localStorage.setItem("guestId", guestId);
  }
  return guestId;
}

export default function Save_inquary({ product }) {
  const [isSaved, setIsSaved] = useState(false);
  const [guestId, setGuestId] = useState(getGuestId());
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const { Toastshow } = Toast();

  const productUid = typeof product === "string" ? product : product?.uid;

  // Replace guestId with user guid if logged in
  useEffect(() => {
    const sessionToken = Cookies.get("sessiontoken");
    const guid = Cookies.get("guid");
    if (sessionToken && guid) setGuestId(guid);
  }, []);

  // Check if inquiry already exists
  useEffect(() => {
    if (!productUid || !guestId) return;

    const checkSaved = async () => {
      try {
        const savedRef = doc(db, "inquary", guestId, "items", productUid);
        const savedSnap = await getDoc(savedRef);
        setIsSaved(savedSnap.exists());
      } catch (err) {
        console.error("Error checking saved:", err);
      }
    };

    checkSaved();
  }, [productUid, guestId]);

  // Save or delete inquiry
  const toggleSave = async () => {
    if (!productUid || !guestId) return;

    if (!mobile || mobile.length !== 10) {
      Toastshow("Please enter a valid 10-digit mobile number.");
      return;
    }

    try {
      // Ensure parent document exists
      const parentRef = doc(db, "inquary", guestId);
      const parentSnap = await getDoc(parentRef);
      if (!parentSnap.exists()) {
        await setDoc(parentRef, {
          guid: guestId,
          name: name.trim(),
           status: true,
          mobile: mobile.trim(),
          sessiontoken: Cookies.get("sessiontoken") || "",
          date_created: new Date(),
        });
      }

      const savedRef = doc(db, "inquary", guestId, "items", productUid);

      if (isSaved) {
       // await deleteDoc(savedRef);
        setIsSaved(false);
        Toastshow("Your inquiry alrdeady saved!");
      } else {
        await setDoc(savedRef, {
          uid: productUid,
          productUid,
         inquiry: name.trim(),          
          mobile: mobile.trim(),
          status: true,
          guid: guestId,
          sessiontoken: Cookies.get("sessiontoken") || "",
          country: Cookies.get("Country") || "",
          state: Cookies.get("State") || "",
          city: Cookies.get("City") || "",
          date_time: new Date(),
        });
        setIsSaved(true);
        Toastshow("Your inquiry was saved successfully!");
      }
    } catch (err) {
      console.error("Error saving inquiry:", err);
      Toastshow("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="save-inquiry items-back p-2 rounded">
    
      <table className="w-full">
        <tbody>
       
          <tr>
            <td width={22}>
              <MdPhone className="icon" />
            </td>
            <td>
              <input
                type="tel"
                className="text-h2 p-1 border w-full"
                value={mobile}
                onChange={(e) =>
                  setMobile(e.target.value.replace(/\D/g, ""))
                }
                placeholder="9188728XXXXX"
                maxLength={10}
              />
            </td>
            
          </tr>
              <tr>
            <td width={22}>
              <MdAccountCircle className="icon" />
            </td>
            <td>
              <textarea
                rows={2}
                className="text-h2 p-1 border w-full"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your inquiry"
             
                maxLength={150}
              />
            </td>
          </tr>
        </tbody>
      </table>
           <div
                className={`button-ui2 fill cursor p-2   ${
                  isSaved ? "green-back" : ""
                }`}
                onClick={toggleSave}
              >
                <MdCallReceived className="icon" />
                {isSaved ? "Saved" : "Call Me"}
              </div>
    </div>
  );
}
